import { ChildProps } from '@apollo/client/react/hoc';
import { gql } from '../gql';
import React from 'react';
import PhotoTiles from './photo_tiles';
import { DiscoRecentlyViewedListingPhotosRow } from '../gql/graphql';
import OverflowingRow from './overflowing_row';

import { withGraphql } from '../with_graphql';

interface IProps {
  title?: string | JSX.Element;
}

const COMPONENT_NAME = 'RecentlyViewedListingPhotosRow';

export function RecentlyViewedListingPhotosRow(props: ChildProps<IProps, DiscoRecentlyViewedListingPhotosRow.Query>) {
  const listings = props.data?.recentlyViewedListings;
  const isLoading = props.data?.loading;
  const shouldRender = listings && listings.length !== 0;

  if (!shouldRender && !isLoading) return null;

  return (
    <OverflowingRow
      title={props.title}
      collectionCount={listings?.length || 12}
      condensed
    >
      <PhotoTiles
        items={listings}
        loading={isLoading}
        trackingName={COMPONENT_NAME}
      />
    </OverflowingRow>
  );
}

const connect = withGraphql<IProps, DiscoRecentlyViewedListingPhotosRow.Query>(
  gql(`
    query Disco_RecentlyViewedListingPhotosRow {
      recentlyViewedListings(input: {
        limit: 12
      }) {
        _id
        ...PhotoTileFields
      }
    }
  `),
  {
    options: {
      ssr: false, // only rendered client side after a user interacts with the site search component, no need for ssr
    },
  },
);

export default connect(RecentlyViewedListingPhotosRow);
